module.exports = __webpack_public_path__ + "img/start.80c27029.png";